<template>
  <div class="workflow-details" v-if="workflow">
    <EntityPathBar
      type="workflow"
      :id="$route.params.id"
      :leafName="workflow?.name"
    />


    <div class="header">
      <h2>{{ isEditMode ? "Edit Workflow" : workflow.name }}</h2>
      <div class="top-buttons">
        <button @click="toggleEditMode" class="icon-btn">
          <i class="bi bi-pencil"></i>
        </button>
        <button class="remove-btn" @click="deleteWorkflow">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>

    <!-- Display mode -->
    <div v-if="!isEditMode">
      <div class="detail"><strong>Status:</strong> {{ workflow.status }}</div>
      <div class="detail"><strong>Start Date:</strong> {{ formatDate(workflow.start_date) }}</div>
      <div class="detail"><strong>End Date:</strong> {{ formatDate(workflow.end_date) }}</div>
      <div class="buttons-container">
      </div>
    </div>

    <!-- Edit mode -->
    <div v-else>
      <div class="form-group">
        <label for="name">Name</label>
        <input type="text" id="name" v-model="editableWorkflow.name">
      </div>
      <div class="form-group">
          <label for="status">Status</label>
          <select id="status" v-model="editableWorkflow.status" class="form-control">
            <option value="contract">Contract</option>
            <option value="to be started">To be started</option>
            <option value="ongoing">Ongoing</option>
            <option value="finished">Finished</option>
          </select>
        </div>
      <div class="form-group">
        <label for="start_date">Start Date</label>
        <input type="datetime-local" id="start_date" v-model="editableWorkflow.start_date">
      </div>
      <div class="form-group">
        <label for="end_date">End Date</label>
        <input type="datetime-local" id="end_date" v-model="editableWorkflow.end_date">
      </div>
      <div class="buttons-container">
        <button @click="saveChanges">Save</button>
        <button @click="cancelEditMode">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { API_ENDPOINTS } from '@/services/config';
import apiService from '@/services/apiService';
import { confirmDelete } from "@/utils/confirmDelete";
import { mapState } from 'vuex';
import EntityPathBar from './EntityPathBar.vue';

export default {
  props: {
    workflow: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      isEditMode: false,
      editableWorkflow: {},
      projectName: "",
    };
  },
  computed: {
    ...mapState(['loggedInUser']), 
  },
  components: {
    EntityPathBar
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    toggleEditMode() {
      this.isEditMode = true;
      this.editableWorkflow = JSON.parse(JSON.stringify(this.workflow));
    },
    async saveChanges() {
      console.log("workflow", this.editableWorkflow)
      this.$emit('updateWorkflow', this.editableWorkflow);
      this.isEditMode = false;
    },
    cancelEditMode() {
      this.isEditMode = false;
    },
    async fetchProjectName() {
      const projectId = this.workflow.project_id;
      try {
        const response = await apiService.fetchResources(API_ENDPOINTS.project(projectId), this.loggedInUser.entra_id);
        this.projectName = response.name;
      } catch (error) {
        console.error('Error fetching project name:', error);
      }
    },
    async deleteWorkflow() {
      const workflowId = this.workflow.id;
      try {
        const isConfirmed = await confirmDelete("Are you sure you want to delete this Workflow?");
        if (!isConfirmed) return; // Exit if the user cancels

        await apiService.deleteResource(API_ENDPOINTS.workflow(workflowId), this.loggedInUser.id, this.loggedInUser.entra_id);
        this.$router.push({ name: "Projects" });
      } catch (error) {
        console.error('Error deleting workflow:', error);
      }
    }
  },
  mounted() {
    this.fetchProjectName();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/main.scss";

.workflow-details {
  max-width: 800px;
  margin: 0 auto;
  padding: 15px 20px;
  border-radius: 8px;
  background-color: $secondary-color;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .workflow-path {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      color: $primary-color;
      margin-bottom: 20px;
    }

    .workflow-path {
      font-size: 1rem;
    }
  }

  .top-buttons {
    display: flex;
    gap: 10px;
  }

  .detail {
    margin-bottom: 10px;
    font-size: 16px;
    strong {
      color: $primary-color;
    }

    pre {
      background-color: $form-color;
      padding: 10px;
      border-radius: 4px;
      overflow: auto;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .buttons-container {
    display: flex;
    justify-content: space-between;
  }
}
</style>
